import { useEffect } from 'react';

import env from '@repo/env';
import Cookies from 'js-cookie';

import {
  COOKIE_AUTH_REDIRECT_KEY,
  EDITOR_AUTH_REDIRECT_KEY,
} from '../global/constants';
import { userStoreSelector, useUserStore } from '../stores/userStore';

/** @knipignore */
export const setAuthRedirectKey = (key: string): void => {
  const expires = new Date();

  expires.setSeconds(expires.getSeconds() + 300);

  Cookies.set(COOKIE_AUTH_REDIRECT_KEY, key, {
    expires,
    sameSite: 'lax',
    domain: env.cookieDomain,
    secure: true,
  });
};

/** @knipignore */
export const removeAuthRedirectKey = (): void => {
  Cookies.remove(COOKIE_AUTH_REDIRECT_KEY);
};

export const useAuthRedirect = (): void => {
  const user = useUserStore(userStoreSelector.loadingUser);

  useEffect(() => {
    if (user === null) {
      setAuthRedirectKey(EDITOR_AUTH_REDIRECT_KEY);
    } else {
      removeAuthRedirectKey();
    }
  }, [user]);
};
